import script from "./ContentLocationPath.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentLocationPath.vue?vue&type=script&lang=ts&setup=true"

import "./ContentLocationPath.vue?vue&type=style&index=0&id=4ababc12&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ababc12"]])

export default __exports__